/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum QuickAccessKnowledgeVisibility {
    None = 1,
    Own = 2,
    Explicit = 3,
}
